import React from 'react';
import { useAuth } from '../context/AuthContext';
import { ShieldOff, Phone, LogOut } from 'lucide-react';

export default function TrialExpiredPage() {
    const { logout } = useAuth();

    return (
        <div data-testid="trial-expired-page" className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-red-950/40 flex items-center justify-center p-4">
            <div className="max-w-md w-full text-center">
                <div className="w-20 h-20 rounded-2xl bg-red-500/15 flex items-center justify-center mx-auto mb-6">
                    <ShieldOff className="w-10 h-10 text-red-400" />
                </div>
                <h1 className="text-2xl font-bold text-white mb-3">Período de prueba finalizado</h1>
                <p className="text-slate-400 mb-8 leading-relaxed">
                    Su período de prueba gratuita de 15 días ha expirado. 
                    Para continuar usando PrestaGest, comuníquese con nosotros para activar su plan.
                </p>
                <div className="bg-slate-800/60 border border-slate-700/50 rounded-xl p-6 mb-6">
                    <div className="flex items-center justify-center gap-3 mb-2">
                        <Phone className="w-5 h-5 text-emerald-400" />
                        <span className="text-white font-medium">Contactar para activar</span>
                    </div>
                    <a 
                        href="tel:7189161401"
                        data-testid="trial-contact-phone"
                        className="text-3xl font-bold text-emerald-400 hover:text-emerald-300 transition-colors block mt-2"
                    >
                        718-916-1401
                    </a>
                </div>
                <button 
                    data-testid="trial-logout-btn"
                    onClick={logout}
                    className="inline-flex items-center gap-2 px-6 py-2.5 text-sm text-slate-400 hover:text-white border border-slate-700 hover:border-slate-500 rounded-lg transition-all"
                >
                    <LogOut className="w-4 h-4" />
                    Cerrar sesión
                </button>
            </div>
        </div>
    );
}
